




















import { Vue, Component } from 'vue-property-decorator'
import util from '@/common/util'
import openShareMask from '@/modules/marketing/activity/component/shareMask'

interface ConfigData {
  // 功能是否开启
  is_opened: boolean;

  // 活动名称
  title: string;

  // 活动id
  activity_id: number;

  // 分享链接
  url: string;

  // 分享图
  image_url: string;

  // urlScheme
  scheme: string;

  // urlScheme 关键Key
  schemeKey: string;
}

@Component
export default class Referral extends Vue {
  invitationConfig: ConfigData = {
    is_opened: false,
    title: '',
    activity_id: 0,
    url: '',
    image_url: '',
    scheme: '',
    schemeKey: ''
  }

  mounted() {
    this.getConfig()
    this.setHideItems()
  }

  async getConfig() {
    const [error, { code, data }] = await this.$rest.marketing.getInvitationConfig().then(res => [null, res]).catch(err => [err, {}])
    if (error || code !== 0) return
    this.invitationConfig = {
      ...data,
      schemeKey: this.handleURLSchema(data.scheme)
    }
  }

  /**
   * 隐藏复制按钮
   */
  setHideItems() {
    const menuItems = [
      'menuItem:editTag',
      'menuItem:delete',
      'menuItem:copyUrl',
      'menuItem:originPage',
      'menuItem:readMode',
      'menuItem:openWithQQBrowser',
      'menuItem:openWithSafari',
      'menuItem:share:email',
      'menuItem:share:brand',
      'menuItem:favorite',
      'menuItem:share:facebook',
      'menuItem:share:QZone',
      'menuItem:share:qq'
    ]
    // @ts-ignore
    this.$wechat.promise.then(wx => {
      // 处理分享到朋友圈
      wx.hideMenuItems({
        menuItems
      })
      // wx.shareWechat(opt)
    }, (wx: { res: any; }) => {
      // 抛出异常
      throw new Error(`微信JSSDK校验错误:${JSON.stringify(wx.res)}`)
    })
  }

  handleURLSchema(scheme: string) {
    const reg = /^(?<url>weixin:\/\/dl\/business\/\?t=)(?<key>\S*)/
    const regExec = reg.exec(scheme)
    return (regExec && regExec.groups && regExec.groups.key) || ''
  }

  /**
   * 设置分享
   */
  async setAppMessage() {
    const { title, is_opened, url, image_url, schemeKey } = this.invitationConfig
    if (!is_opened) {
      util.showToast('未开启转介绍功能')
    }
    const shareData = {
      title: `每邀请一位好友购车，得${title}！`, // 分享标题
      desc: '快来参加老客户转介绍，享门店好礼活动吧', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      link: `${url}&scheme=${schemeKey}`,
      imgUrl: image_url // 分享图标
    }
    // @ts-ignore
    await this.$wechat.promise.then(wx => {
      // 处理分享到朋友圈
      wx.shareTimeline(shareData)
      // 处理分享给好友
      wx.shareAppMessage(shareData)
      // wx.shareWechat(opt)
    }, (wx: { res: any; }) => {
      // 抛出异常
      throw new Error(`微信JSSDK校验错误:${JSON.stringify(wx.res)}`)
    })
    openShareMask()
  }
}
